export default function FAQSection() {
  const faqs = [
    {
      q: '韩漫网站的漫画都是免费观看的吗？',
      a: '是的！韩漫网站上的所有韩国漫画作品均提供免费在线观看服务。我们致力于为韩漫爱好者打造一个高质量的免费阅读平台，无需付费即可畅读所有热门连载和完结作品。',
    },
    {
      q: '什么是下拉式阅读体验？',
      a: '下拉式阅读是专为手机和网页端优化的漫画阅读方式。与传统的翻页模式不同，您只需向下滑动屏幕即可连续阅读整话内容，画面切换流畅自然，无需等待加载，带来沉浸式的阅读享受。',
    },
    {
      q: '网站多久更新一次漫画内容？',
      a: '我们每日同步更新热门连载漫画的最新章节，确保读者能够第一时间看到心仪作品的新内容。同时也会定期上架新作品，丰富漫画库的种类和数量。',
    },
    {
      q: '可以在手机上观看吗？',
      a: '当然可以！韩漫网站完美适配手机、平板和电脑端。无论您使用什么设备，都能享受到流畅的下拉式阅读体验。只需打开浏览器访问我们的网站即可，无需下载任何APP。',
    },
    {
      q: '漫画的画质怎么样？',
      a: '我们平台上的所有漫画均提供高清画质，色彩还原准确，细节清晰可见。每一话都经过精心优化，确保在不同设备上都能呈现最佳的视觉效果。',
    },
  ];

  return (
    <section className="bg-background-100 py-16 md:py-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6 lg:px-10">
        <div className="text-center mb-12">
          <p className="text-sm text-foreground-500 font-medium tracking-wider uppercase mb-3">
            常见问题
          </p>
          <h2 className="font-heading text-3xl md:text-4xl font-black text-foreground-950 leading-tight">
            关于韩漫网站
          </h2>
        </div>

        <div className="flex flex-col gap-3">
          {faqs.map((faq, index) => (
            <details key={index} className="group bg-background-50 rounded-2xl overflow-hidden cursor-pointer">
              <summary className="flex items-center justify-between p-5 md:p-6 font-medium text-foreground-900 text-sm md:text-base list-none">
                <span>{faq.q}</span>
                <i className="ri-add-line text-lg text-foreground-400 group-open:hidden transition-transform"></i>
                <i className="ri-subtract-line text-lg text-primary-500 hidden group-open:block transition-transform"></i>
              </summary>
              <div className="px-5 md:px-6 pb-5 md:pb-6">
                <p className="text-sm text-foreground-600 leading-relaxed">{faq.a}</p>
              </div>
            </details>
          ))}
        </div>
      </div>
    </section>
  );
}